'use client';

import {useEffect, useState} from 'react';
import {useNewThemeContext} from '../contexts/NewThemeContext';
import {USE_PIXEL_PARTY_THEME_V2} from '../styles/themes/theme-feature-flag-mock';

export function useNewTheme() {
  const contextValue = useNewThemeContext();
  const [localApplyNewTheme, setLocalApplyNewTheme] = useState(false);

  useEffect(() => {
    // Skip local computation when a host app provides the value via context
    if (contextValue !== undefined) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get('theme') && params.get('theme') === 'blue') {
      setLocalApplyNewTheme(true);
    } else {
      USE_PIXEL_PARTY_THEME_V2
        ? setLocalApplyNewTheme(true)
        : setLocalApplyNewTheme(false);
    }
  }, [contextValue]);

  return {
    applyNewTheme:
      contextValue !== undefined
        ? contextValue.applyNewTheme
        : localApplyNewTheme,
  };
}
